import { useCallback, useEffect, useState } from "react";

export function useAdditionalEmails(formValues = {}, onChange) {
  if (typeof onChange !== "function") {
    throw new Error("useAdditionalEmails: onChange is required");
  }

  const [blurredAdditionalEmails, setBlurredAdditionalEmails] = useState(
    () => new Set()
  );

  useEffect(() => {
    if (formValues.additionalEmails == null) {
      onChange("additionalEmails", []);
    }
  }, [onChange, formValues.additionalEmails]);

  const handleAddEmail = useCallback(
    (i, event) => {
      const values = [...(formValues.additionalEmails || [])];
      values[i] = event.target.value;
      onChange("additionalEmails", values);
    },
    [formValues.additionalEmails, onChange]
  );

  const removeClick = useCallback(
    (i) => {
      const values = [...(formValues.additionalEmails || [])];
      values.splice(i, 1);
      onChange("additionalEmails", values);
    },
    [formValues.additionalEmails, onChange]
  );

  const addEmailInput = useCallback(() => {
    const values = [...(formValues.additionalEmails || [])];
    values.push("");
    onChange("additionalEmails", values);
  }, [formValues.additionalEmails, onChange]);

  const handleAdditionalEmailBlur = useCallback((index) => {
    setBlurredAdditionalEmails((prev) => new Set(prev).add(index));
  }, []);

  return {
    blurredAdditionalEmails,
    handleAddEmail,
    removeClick,
    addEmailInput,
    handleAdditionalEmailBlur,
  };
}
